import { ActivityEntityName } from '../../../../entities';
import { MergeField, MergeSchema, getSchema } from '../../decorators';
import { FinancialItemLineMergeData } from './financial.item.line.merge.data';

@MergeSchema({
    entity: ActivityEntityName.SaleOrderItems,
    name: 'SaleOrderItemsMergeDataSchema',
})

export class SaleOrderItemsMergeData {
    @MergeField({
        arraySchemaName: 'FinancialItemLineMergeDataSchema'
    })
    items: FinancialItemLineMergeData[] = [];
}

export const SaleOrderItemsMergeDataSchema = getSchema(SaleOrderItemsMergeData)